import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useCurrentUser } from "@/lib/auth/use-current-user";
import { isLocale } from "./index";

/**
 * Applies the signed-in user's saved language (`users.locale`) as soon as the
 * row is known, and keeps `<html lang>` in step with the displayed language.
 * Renders nothing.
 */
export function LocaleSync() {
  const { data: user } = useCurrentUser();
  const { i18n } = useTranslation();
  const preferred = user?.locale;

  useEffect(() => {
    if (isLocale(preferred) && preferred !== i18n.language) {
      void i18n.changeLanguage(preferred);
    }
  }, [preferred, i18n]);

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return null;
}
